import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_2 = { class: "choose-options" }
const _hoisted_3 = ["onClick", "id", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "ifAfterDeadline"
}
const _hoisted_5 = {
  key: 0,
  class: "option-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Warning = _resolveComponent("Warning")!
  const _component_CustomCard = _resolveComponent("CustomCard")!

  return (_openBlock(), _createBlock(_component_CustomCard, { optClass: "step" }, {
    "step-number": _withCtx(() => [
      _hoisted_1
    ]),
    "step-title": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("NEW_TICKET.CHOOSE_TYPE")), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formTypes, (formType) => {
          return (_openBlock(), _createElementBlock("button", {
            key: formType.id,
            onClick: ($event: any) => (_ctx.setTicketType(formType.id)),
            id: formType.label,
            class: _normalizeClass(["option-btn", { active: _ctx.ticketType === formType.id }]),
            disabled: _ctx.isButtonDisabled(formType)
          }, _toDisplayString(_ctx.t(`COMMON.RETURN_TYPES.${formType.id}.DESCRIPTION`)), 11, _hoisted_3))
        }), 128)),
        (_ctx.orderAfterDeadline)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.change)
                ? (_openBlock(), _createBlock(_component_Warning, {
                    key: 0,
                    text: _ctx.t('NEW_TICKET.ORDER_AFTER_DEADLINE_CHANGE')
                  }, null, 8, ["text"]))
                : (_openBlock(), _createBlock(_component_Warning, {
                    key: 1,
                    text: _ctx.t('NEW_TICKET.ORDER_AFTER_DEADLINE')
                  }, null, 8, ["text"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.ticketType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.t(`COMMON.RETURN_TYPES.${_ctx.ticketType}.TEXT`)), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}